module.exports = __webpack_public_path__ + "img/14.b3cfb42c.jpg";